import { create } from 'zustand';

export type DockPosition = 'floating' | 'right' | 'bottom';

interface LayoutState {
  // Properties Panel docking
  propertiesPanelDock: DockPosition;
  propertiesPanelSize: { width: number; height: number };
  
  // Actions
  setPropertiesPanelDock: (position: DockPosition) => void;
  setPropertiesPanelSize: (size: { width: number; height: number }) => void;
}

export const useLayoutStore = create<LayoutState>((set) => ({
  // Initial state
  propertiesPanelDock: 'floating',
  propertiesPanelSize: { width: 600, height: 700 },
  
  // Actions
  setPropertiesPanelDock: (position) => 
    set({ propertiesPanelDock: position }),
  
  setPropertiesPanelSize: (size) => 
    set({ propertiesPanelSize: size }),
})); 